module.exports = __webpack_public_path__ + "img/Post_Video.063a8e30.svg";